import { validateFormulaSyntax } from './validate'
import { parseFormula, collectFunctionNames } from './parser'

describe('collectFunctionNames', () => {
  it('중첩 함수명을 중복 없이 수집한다', () => {
    expect(collectFunctionNames(parseFormula('sum(round([a], 2), avg([b], [c]))')).sort()).toEqual([
      'avg',
      'round',
      'sum'
    ])
  })
  it('함수 없으면 빈 배열', () => {
    expect(collectFunctionNames(parseFormula('[a] + [b]'))).toEqual([])
  })
})

describe('validateFormulaSyntax (순수, DB 무관)', () => {
  it('정상 수식: 에러 없음 + 변수 추출', () => {
    const r = validateFormulaSyntax('([실제공사비] - [계획공사비]) / [계획공사비]')
    expect(r.errors).toEqual([])
    expect(r.variables.sort()).toEqual(['계획공사비', '실제공사비'].sort())
  })

  it('구문 오류는 에러로 (파싱 실패)', () => {
    expect(validateFormulaSyntax('[a] +').errors.length).toBeGreaterThan(0)
    expect(validateFormulaSyntax('(1 + 2').errors[0]).toMatch(/구문 오류/)
    expect(validateFormulaSyntax('1 @ 2').errors[0]).toMatch(/구문 오류/)
  })

  it('알 수 없는 함수는 에러', () => {
    expect(validateFormulaSyntax('bogus([a])').errors.some(e => /알 수 없는 함수/.test(e))).toBe(true)
  })

  it('빌트인 함수(sum/round/if)는 통과', () => {
    expect(validateFormulaSyntax('round(sum([a], [b]) / 2, 1)').errors).toEqual([])
    expect(validateFormulaSyntax('if([a], [b], [c])').errors).toEqual([])
  })

  it('순수 단계에서 warnings 는 비어있고, 미정의 변수도 여기선 에러 아님(변수로 추출만)', () => {
    const r = validateFormulaSyntax('[없는변수] / 2')
    expect(r.warnings).toEqual([])
    expect(r.errors).toEqual([])
    expect(r.variables).toEqual(['없는변수'])
  })

  it('커스텀 함수 화이트리스트를 존중한다', () => {
    expect(validateFormulaSyntax('myfn(1)', new Set(['myfn'])).errors).toEqual([])
  })
})
